type Value = string | null | undefined;

export class ValueParser {
  static string(value: Value, defaultValue?: string): string | undefined {
    return value ?? defaultValue;
  }

  static number(value: Value, defaultValue?: number) {
    if (value === null || value === undefined) {
      return defaultValue;
    }

    const numericValue = Number(value);

    if (Number.isNaN(numericValue) === true) {
      return defaultValue;
    }

    return numericValue;
  }

  static boolean(value: Value, defaultValue?: boolean) {
    if (value === "true") {
      return true;
    }

    if (value === "false") {
      return false;
    }

    return defaultValue;
  }

  static literal<T extends string>(
    value: Value,
    allowedValues: T[],
    defaultValue: T,
  ): T {
    if (value !== null && value !== undefined) {
      if (allowedValues.includes(value as T)) {
        return value as T;
      }
    }

    return defaultValue;
  }

  static array(value: Value): string[] {
    if (value === null || value === undefined) {
      return [];
    }

    return value.split(",");
  }

  static numberArray(value: Value): number[] {
    return this.array(value)
      .map((value) => this.number(value))
      .filter((value) => value !== undefined);
  }
}
